module.exports = __webpack_public_path__ + "img/ic_doc2.20906982.svg";